import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { BreadcrumbModel } from '../breadcrumbs/breadcrumb.models';
import { BreadcrumbsResolve } from '../breadcrumbs/breadcrumbs.resolver';
import { MultiBuilderCrumbList } from './multi-builder.model';

@Injectable()
export class MultiBuilderBreadcrumbsResolver extends BreadcrumbsResolve<MultiBuilderCrumbList> {
    constructor(
        private urlHelper: UrlHelperService,
        private sitecore: Sitecore,
    ) {
        super();
    }

    protected customResolve(model: MultiBuilderCrumbList): BreadcrumbModel[] {
        return [
            this.createCrumb({
                icon: this.sitecore.multiBuilder.header.icon,
                title: this.sitecore.multiBuilder.header.text,
                url: this.urlHelper.getMultiBuilderUrl(),
            }),
        ];
    }
}
